import { useContext, useState } from "react";
import { Input } from "../../components/generic/Input";
import Modal from "../../components/generic/Modal";
import RegisterModal from "./components/RegisterModal";
import useForm from "../../hooks/form.hook";
import { isAnyBlank, isBlank } from "../../util/base.util";
import { AuthContext } from "../../contexts/auth.context";
import { LucideAlertOctagon } from "lucide-react";

export default function LoginPage() {
    const auth = useContext(AuthContext);
    const [modalOpen, setModalOpen] = useState(false);
    const form = useForm({
        id: "",
        password: ""
    });

    function login() {
        form.clearErrors();

        form.submit("auth/login", {
            onError: form.setErrors,
            onSuccess: (data) => {
                auth.setToken(data.token);
            }
        });
    }

    return (
        <>
        <div className="flex items-center justify-center h-svh p-4" style={{
            background: "url('/images/splash_bg.png') no-repeat center center"
        }}>
            <div className="w-screen max-w-sm text-center">
                
                <div className="avatar">
                    <div className="w-16">
                        <img src="/logo192.png" alt="Logo" />
                    </div>
                </div>
                <p className="mt-2 text-2xl">Lister</p>

                <div className="grid gap-4 my-4 text-left">
                    <div>
                        <Input disabled={form.isLoading} name="id" type="text" placeholder="Username or Email address"
                        value={form.state.id} onChange={form.setFromInput}
                        className="bg-transparent w-full" />
                    </div>
                    <div>
                        <Input disabled={form.isLoading} name="password" type="password" placeholder="Password"
                        value={form.state.password} onChange={form.setFromInput}
                        onKeyDown={e => {
                            if (e.key === "Enter") login();
                        }}
                        className="bg-transparent w-full" />
                    </div>
                    <div>
                        <button disabled={form.isLoading || isAnyBlank(form.state.id, form.state.password)} onClick={login} className="btn btn-primary w-full">{form.loadText("Sign in")}</button>
                    </div>
                    <div className="divider m-0"></div>
                    <div>
                        <button onClick={() => setModalOpen(true)} className="btn btn-ghost w-full">Sign up</button>
                    </div>
                </div>
            </div>
        </div>

        <RegisterModal id="register_modal" open={modalOpen} onClose={() => setModalOpen(false)} />
        </>
    );
}